import { useEffect } from 'react'
import { useAppStore } from '../store/appStore'
import { setUserProperties } from 'firebase/analytics'
import { firebaseAnalytics } from '../firebaseConfig'
import { setTag } from '@sentry/react'

export const useUrlParams = () => {
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search)
        console.info('[useUrlParams]', urlParams.toString())

        useAppStore.setState({
            // `templateform` is Medicore's launch param name for the pre-selected template;
            // `templateId` is the canonical name. The external-id to Medendo-template
            // translation is handled downstream.
            preSelectedTemplateId: urlParams.get('templateId') ?? urlParams.get('templateform'),
            preSelectedPatientId: urlParams.get('patientId') ?? urlParams.get('patient'),
            isPatientPinned: urlParams.get('pinPatient') === 'true',
            isTemplatePinned: urlParams.get('pinTemplate') === 'true',
            isIntegration: !!urlParams.get('integration'),
            // Launch context selected by the embedding EHR, e.g. 'process-appointment'.
            integrationOrigin: urlParams.get('origin'),
        })

        if (useAppStore.getState().isIntegration) {
            setUserProperties(firebaseAnalytics, { auth_provider: 'integration' })
            setTag(`auth_provider`, 'integration')
        }

        window.history.replaceState({}, document.title, window.location.pathname)
    }, [])
}
